import React from "react";

{/* The blue blurred circle in the top right corner of Profile page. */}
const TopRightPageBlueBg = () => {
  return (
    <div
      className="absolute right-[-350px] top-[150px] h-[590px] w-[590px] rounded-full bg-primary_lt"
      style={{ filter: "blur(150px)" }}
    />
  );
};

export default TopRightPageBlueBg;
